import React from 'react';
import { Link } from 'react-router-dom';
import { MenuIcon, BellIcon, UserIcon, LogOutIcon } from 'lucide-react';
import Logo from './Logo';
import { useAuth } from '../contexts/AuthContext';
interface HeaderProps {
  toggleMobileMenu: () => void;
}
const Header = ({
  toggleMobileMenu
}: HeaderProps) => {
  const {
    user,
    logout
  } = useAuth();
  return <header className="bg-white border-b border-neutral-100 sticky top-0 z-10" data-id="element-78">
      <div className="container mx-auto px-4 h-16 flex items-center justify-between" data-id="element-79">
        <div className="flex items-center" data-id="element-80">
          <button className="md:hidden mr-4 p-2 rounded-full hover:bg-neutral-50" onClick={toggleMobileMenu} aria-label="Toggle menu" data-id="element-81">
            <MenuIcon className="w-6 h-6 text-neutral-500" data-id="element-82" />
          </button>
          <Link to="/" className="flex items-center" data-id="element-83">
            <Logo data-id="element-84" />
          </Link>
        </div>
        <div className="flex items-center space-x-4" data-id="element-85">
          {user && <>
              <button className="p-2 rounded-full hover:bg-neutral-50" aria-label="Notifications" data-id="element-86">
                <BellIcon className="w-6 h-6 text-neutral-400" data-id="element-87" />
              </button>
              <div className="hidden md:flex items-center" data-id="element-88">
                <div className="w-10 h-10 rounded-full bg-secondary flex items-center justify-center" data-id="element-89">
                  <UserIcon className="w-5 h-5 text-white" data-id="element-90" />
                </div>
                <div className="ml-2" data-id="element-91">
                  <div className="text-sm font-medium" data-id="element-92">{user.name}</div>
                  <div className="text-xs text-neutral-400" data-id="element-93">
                    {user.role === 'msme' && 'MSME Owner'}
                    {user.role === 'investor' && 'Investor'}
                    {user.role === 'shariah' && 'Shariah Advisor'}
                    {user.role === 'trustee' && 'Trustee'}
                    {user.role === 'digital-advisor' && 'Digital Advisor'}
                  </div>
                </div>
              </div>
              <button onClick={logout} className="p-2 rounded-full hover:bg-neutral-50 hidden md:block" aria-label="Sign out" data-id="element-94">
                <LogOutIcon className="w-6 h-6 text-neutral-400" data-id="element-95" />
              </button>
            </>}
          {!user && <Link to="/login" className="bg-primary text-white px-4 py-2 rounded text-sm font-medium hover:bg-primary-dark" data-id="element-96">
              Sign In
            </Link>}
        </div>
      </div>
    </header>;
};
export default Header;